export default __webpack_public_path__ + "static/media/lapy01.edec5a6a.png";